import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

export const incrementSessionRefreshPageLoad = () => {
  clientSideMetrics.counter('session_refresh_page_initiation').increment()
}

export const incrementSessionRefreshPendingStatusTimeout = () => {
  clientSideMetrics.counter('session_refresh_expiration_timeout').increment()
}
